<div [class.re-inline-label]="formConfig.inlineLabel">
  <re-label [formConfig]="formConfig" [disabled]="disabledState"></re-label>
  <div class="re-control">
    <select
      #select
      class="form-select"
      [class.re-unselected]="!selectedValue"
      [id]="formConfig.id"
      [attr.name]="formConfig.name"
      [attr.aria-label]="formConfig.ariaLabel"
      [attr.aria-describedby]="ariaDescribedBy()"
      [attr.ngbautofocus]="formConfig.autoFocus ? '' : undefined"
      [disabled]="disabledState"
      (change)="onChange(select.value)"
      (blur)="onBlur($event)">
      @if (formConfig.placeholder) {
        <option value="">
          {{ formConfig.placeholder }}
        </option>
      } @else {
        <option disabled hidden></option>
      }
      @for (option of options; track option) {
        <option [value]="valueProperty(option)" [disabled]="disabledProperty(option)">
          {{ displayProperty(option) }}
        </option>
      }
    </select>
    @if (displayErrorMessage()) {
      <div class="form-text">{{ errorMessage }}</div>
    }
  </div>
</div>
